export default "__VITE_ASSET__USQi0irx__"